import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "@core/services/entities/auth.service";
import { CompanySelectorService } from "@core/services/presenters/company-selector.service";
import { HEADER_X_ORGANIZATION_COMPANY } from "@shared/utils/constants/http.constant";
import { isVarEmpty } from "@shared/utils/functions/common.function";

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const companySelectorService = inject(CompanySelectorService);

  const token: string = authService.currentAccessToken;
  const organizationCompanyRefId = companySelectorService.selectedCompanyRefId();

  let modifiedReq = req.clone();

  if (!isVarEmpty(token)) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  if (!isVarEmpty(organizationCompanyRefId)) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { [HEADER_X_ORGANIZATION_COMPANY]: organizationCompanyRefId },
    });
  }

  if (!isVarEmpty(modifiedReq.headers.has('Content-Type'))) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { 'Content-Type': 'application/json; charset=UTF-8' },
    });
  }

  return next(modifiedReq);
};
